import {Box} from "@mui/material";
import {FC} from "react";
import {useParams} from "react-router-dom";
import {makeStyles} from "tss-react/mui";
import {LessonPage} from "./LessonPage/LessonPage";
// import { SurveyPage } from "./SurveyPage/SurveyPage"; // TODO: Implement SurveyPage if needed
// NOTE: QuizPage removed - only inline quizzes via MiniQuizzer are used

const useStyles = makeStyles<{ moduleType?: string }>()((theme, {moduleType}) => ({
	pageBase: {
		height: "100%",
		"& [class*='background']": moduleType !== "quiz" && {
			backgroundColor: "white",
			[theme.breakpoints.down("sm")]: {
				backgroundColor: "#F2F1F4"
			}
		}
	}
}));

/**
 * Module Page Router
 * 
 * Determines which module type (lesson, quiz, survey) to render
 * based on the :moduleType URL parameter.
 * 
 * Uses React Query instead of context providers for data fetching.
 */
export const ModulePage: FC = () => {
	const {moduleSlug, moduleType} = useParams<{ moduleSlug: string; moduleType: string }>();
	const {classes} = useStyles({moduleType});

	if (!moduleSlug) return <></>;

	return (
		<Box className={classes.pageBase}>
			{moduleType === "lesson" && <LessonPage />}
			{/* Quiz rendering removed - only inline quizzes via MiniQuizzer are used */}
			{/* {moduleType === "survey" && <SurveyPage />} */}
		</Box>
	);
};

